import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconWidgetReferral = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      className="block w-full h-full fill-current"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 14C11.3431 14 10 15.3431 10 17C10 18.6569 11.3431 20 13 20C14.6569 20 16 18.6569 16 17C16 15.3431 14.6569 14 13 14ZM8 17C8 14.2386 10.2386 12 13 12C15.7614 12 18 14.2386 18 17C18 19.7614 15.7614 22 13 22C10.2386 22 8 19.7614 8 17ZM7.08296 30H18.917C18.441 27.1623 15.973 25 13 25C10.027 25 7.55904 27.1623 7.08296 30ZM5 31C5 26.5817 8.58172 23 13 23C17.4183 23 21 26.5817 21 31C21 31.5523 20.5523 32 20 32H6C5.44772 32 5 31.5523 5 31Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 4C26.3431 4 25 5.34315 25 7C25 8.65685 26.3431 10 28 10C29.6569 10 31 8.65685 31 7C31 5.34315 29.6569 4 28 4ZM23 7C23 4.23858 25.2386 2 28 2C30.7614 2 33 4.23858 33 7C33 9.76142 30.7614 12 28 12C25.2386 12 23 9.76142 23 7ZM22.083 20H33.917C33.441 17.1623 30.973 15 28 15C25.027 15 22.559 17.1623 22.083 20ZM20 21C20 16.5817 23.5817 13 28 13C32.4183 13 36 16.5817 36 21C36 21.5523 35.5523 22 35 22H21C20.4477 22 20 21.5523 20 21Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.8739 30.0821C33.4833 30.4726 32.8502 30.4726 32.4596 30.0821L29.9167 27.5392L29.9167 32.2083C29.9167 35.8902 26.932 38.875 23.2501 38.875L21.8334 38.875C21.2811 38.875 20.8334 38.4273 20.8334 37.875C20.8334 37.3227 21.2811 36.875 21.8334 36.875L23.2501 36.875C25.8274 36.875 27.9167 34.7857 27.9167 32.2083L27.9167 27.5392L25.3739 30.0821C24.9833 30.4726 24.3502 30.4726 23.9596 30.0821C23.5691 29.6916 23.5691 29.0584 23.9596 28.6679L28.2096 24.4179C28.6002 24.0274 29.2333 24.0274 29.6239 24.4179L33.8739 28.6679C34.2644 29.0584 34.2644 29.6916 33.8739 30.0821Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 28C13 27.4477 13.4477 27 14 27H16C16.5523 27 17 27.4477 17 28C17 28.5523 16.5523 29 16 29H14C13.4477 29 13 28.5523 13 28Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 18C28 17.4477 28.4477 17 29 17H31C31.5523 17 32 17.4477 32 18C32 18.5523 31.5523 19 31 19H29C28.4477 19 28 18.5523 28 18Z"
      />
    </svg>,
  );

IconWidgetReferral.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconWidgetReferral;
